import { useState, useRef, createElement, forwardRef } from "react";
import './index.scss';
import classNames from "classnames";
import Button from "../colorful-button";
const ColorfulCaptcha = forwardRef(({ label = '短信验证码', placeholder = '输入验证码', onClick, ...otherProps }, ref) => {
    const inputRef = useRef(null);
    const _otherProps = otherProps || {};
    const [codeTime, setCodeTime] = useState(60);
    const [showCode, setShowCode] = useState(true);
    const prefixCls = `au-captcha`;
    const classString = classNames(prefixCls);
    const classCode = classNames('inner-code-time', {
        [`inner-code-time-active`]: !showCode,
    });
    const handleClick = (e) => {
        if (showCode) {
            setShowCode(false);
            let newTime = codeTime;
            const timer = setInterval(() => {
                newTime--;
                setCodeTime(newTime);
                if (newTime === 0) {
                    clearInterval(timer);
                    setCodeTime(60);
                    setShowCode(true);
                }
            }, 1000);
        }
        if (onClick) {
            onClick(e);
        }
    };
    return (createElement("div", { className: classString, ..._otherProps },
        createElement("label", { className: 'inner-label' }, label || '短信验证码'),
        createElement("div", { className: 'inner-content' },
            createElement("input", { className: 'inner-input', placeholder: placeholder || '输入文本', ref: ref || inputRef })),
        createElement("div", { className: classCode },
            showCode && createElement(Button, { link: true, onClick: handleClick }, "\u53D1\u9001\u9A8C\u8BC1\u7801"),
            !showCode && createElement("span", { className: "code-time" },
                codeTime,
                " \u79D2\u91CD\u65B0\u53D1\u9001"))));
});
ColorfulCaptcha.displayName = 'ColorfulCaptcha';
export default ColorfulCaptcha;
